import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WorkshopCodeService {
  getWorshopCode(workshopName: string) {
    switch (workshopName) {
      case 'Compliance Workshop – Data Risk Management Workshop': {
        return 'COM';
      }
      case 'Identity Workshop': {
        return 'IDE';
      }
      case 'Secure Remote Work Workshop': {
        return 'SRWW';
      }
      case 'Security Workshop': {
        return 'SEC';
      }
      case 'Teams Apps and Solutions Workshop': {
        return 'TAPPS';
      }
      case 'Teams Calling Workshop': {
        return 'TCALL';
      }
      case 'Teams Meetings Workshop': {
        return 'TMEET';
      }
      case 'Endpoint Management Workshop': {
        return 'EPM';
      }
      case 'Secure Work From Anywhere Workshop': {
        return 'SWA';
      }
      case 'Azure Analytics Workshop': {
        return 'AZA';
      }
      case 'Security Workshop + Threat check': {
        return 'SEC';
      }
      case 'Security Workshop only': {
        return 'SEC';
      }
      case 'Teams Adoption Workshop': {
        return 'TAPPS';
      }
      case 'Security Pre-Sales Activity Workshop': {
        return 'SPSAW';
      }
      case 'Security Request for Proposal': {
        return 'SRFP';
      }
      case 'Threat Protection Workshop': {
        return 'TPW';
      }
      case 'Azure Sentinel Workshop': {
        return 'ASW';
      }
      case 'Hybrid Cloud Security Workshop': {
        return 'HCSW';
      }
      case 'Discover Sensitive Data Workshop': {
        return 'DSDW';
      }
      case 'Manage and Investigate Risk Workshop': {
        return 'MIRW';
      }
      case 'Custom Security Workshop (Microsoft pre-approved)': {
        return 'CSW';
      }
      case 'Operator Workshop': {
        return 'OW';
      }
      case 'Operator Request for Proposal': {
        return 'ORFP';
      }
      case 'Deal Association': {
        return 'DA';
      }
      case 'Defend Against Threats with SIEM Plus XDR Workshop': {
        return 'DATWSPX';
      }
      case 'Secure Multi-Cloud Environments Workshop': {
        return 'SMCE';
      }
      case 'Protect and Govern Sensitive Data Workshop': {
        return 'PGSD';
      }
      case 'Mitigate Compliance and Privacy Risks Workshop': {
        return 'MCPR';
      }
      case 'Frontline Worker - Workshop': {
        return 'FWW';
      }
      case 'Frontline Worker - Deal Association': {
        return 'FWDA';
      }
      case 'Microsoft Viva - Workshop': {
        return 'MVW';
      }
      case 'Microsoft Viva - Deal Association': {
        return 'MVDA';
      }
      default: {
        return 'NA';
      }
    }
  }

  getEventWorkshopCode(workshopName: string) {
    switch (workshopName) {
      case 'M365 for business workshop': {
        return 'M365BW';
      }
      case 'Microsoft Teams Essentials Workshop': {
        return 'MSTEW';
      }
      default: {
        return 'NA';
      }
    }
  }
}
